export const environment = {
    production: false,
    debug     : true,
    api       : {
        graphql: 'https://hip-ama-aurora-back-development.azurewebsites.net/graphql',
        rest   : 'https://hip-ama-aurora-back-development.azurewebsites.net/',
    },
    lang: {
        base    : 'es',
        fallback: 'es',
        langs   : ['es','en'],
    },
    oAuth: {
        applicationCode  : 'aurora',
        applicationSecret: '$2y$10$EOA/SKEwKRgHPw64kO4LZ.6oy5b8kl6JzW/mCROMfSq6S38/IiywG',
    },
    appearance: {
        theme : 'theme-default',
        layout: 'classy',
    },
    msEntraId: {
        tenant: 'b6fbec92-ea74-4b61-a8a5-0ca5e669dca2',
        authority: 'https://login.microsoftonline.com/b6fbec92-ea74-4b61-a8a5-0ca5e669dca2',
        clientId: '9dc9d73e-9eca-49fe-9d33-cd7f6d8cb571',
        redirectUri: 'https://ama-dev.hipartnerscloud.com/',
        scopes: ['api://f731b8b7-d741-4335-9cbc-9c7bef9de61d/access_as_user'],
    }
};
